// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"H3-z","paperCutsLineHeight":"I3-z"};